import { DataVolume, Entity } from 'gossamer-unified';
import { Transaction } from './Transaction';
import { TransRow } from './TransRow';

export interface TransRowViewRow {
  trans_id: string;
  user_id: string;
  role_id: string;
  status: string;
  front_end_save_at: number;
  back_end_save_at: number;
  front_end_path: string;
  back_end_path: string;
  outcome_id: string;
  reason: string;
  entity_id: string;
  key: string;
  action: string;
}

export const TransRowView: Entity<TransRowViewRow> = {
  id: 'TransRowView',
  title: 'Transaction Change',
  service: 'main',
  rowLabel: (row: TransRowViewRow) => row.trans_id,
  primaryKeyFields: ['trans_id'],
  source: {
    tableName: 'public.trans_row_view',
  },
  security: [{ role: 'staff', action: 'read', access: 'all' }],
  defaultSort: [['back_end_save_at', 'DESC']],
  defaultFilters: [
    { fieldId: 'entity_id', operator: 'ct', value: '' },
    { fieldId: 'key', operator: 'ct', value: '' },
  ],
  listRowLink: '/admin/transaction/display/{key}',
  dataVolume: DataVolume.Large,
  fields: {
    trans_id: Transaction.fields.trans_id,
    user_id: Transaction.fields.user_id,
    role_id: Transaction.fields.role_id,
    status: Transaction.fields.status,
    front_end_save_at: Transaction.fields.front_end_save_at,
    back_end_save_at: Transaction.fields.back_end_save_at,
    front_end_path: Transaction.fields.front_end_path,
    back_end_path: Transaction.fields.back_end_path,
    outcome_id: Transaction.fields.outcome_id,
    reason: Transaction.fields.reason,
    entity_id: TransRow.fields.entity_id,
    key: TransRow.fields.key,
    action: TransRow.fields.action,
  },
};
